<template>
  <div
    v-if="allSections"
    class="contactCenter-entity-detalization"
  >
    <template v-for="(section, index) in sections">
      <component :key="index" :is="section.component" :section="section" :vObj="vObj" />
    </template>
  </div>
</template>

<script>
import Field from "@/components/contactCenter/components/field/Index.vue"; 
import {mapState} from "vuex";

export default {
  name: "ContactCenterEntityDetalization",

  props: {
    vObj: {}
  },

  computed: {
    ...mapState({
      allSections: state => state.contactCenter.allSections,
      generalSection: state => state.contactCenter.generalSection,
    }),

    sections() {
      return this.allSections ? [...this.allSections].map(section => ({
        ...section,
        component: section.component ? () => import(`@/components/contactCenter/entity/default/page/sections/${section.component}.vue`) : () => import(`@/components/contactCenter/entity/default/page/sections/${section.name}.vue`)
      })) : []
    },
  }
}
</script>

<style lang="scss">
.contactCenter-entity-detalization {
  background: $color_white;
  padding: 15px 45px 280px 20px;
  width: 100%;
}
</style>
